export const FilterButtonSVG = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
  >
    <path
      d="M25.6663 3.5H2.33301L11.6663 14.5367V22.1667L16.333 24.5V14.5367L25.6663 3.5Z"
      stroke="#222222"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
